<template>
  <v-container fluid>
    <template v-for="(post, index) in birdingBirding">
      <v-card :key="index" target="_blank" elevation="0" max-width="100%" color="white" hover>
        <v-card-title class="title">{{post.title}}</v-card-title>
        <template v-for="(position, i) in post.positions">
          <v-row class="nomargin" :key="i">
            <v-col class="cols" cols="12">
              <p class="text" v-html="(i+1)+'. '+position">{{i+1}}</p>
            </v-col>
          </v-row>
        </template>
        <v-divider />
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "BirdingContent",
  computed: {
    ...mapState(["loadingBirding"]),
    ...mapGetters(["birdingBirding"])
  },
  mounted() {
    if (!this.birdingBirding.length) this.$store.dispatch("cargarBirding");
  }
};
</script>

<style scoped>
/deep/.url {
  text-decoration-line: none;
  color: #b80b0b !important;
  font-style: italic;
}

.title {
  text-align: justify;
  font-size: 3.2vmin !important;
  text-decoration-line: underline;
  word-break: break-word;
}

.subtitle {
  text-align: start;
  font-size: 2.2vmin !important;
  word-break: break-word;
}

.text {
  text-align: justify;
  padding-right: 1rem;
  padding-left: 1rem;
  font-size: 2.4vmin !important;
  margin-bottom: 0;
  word-break: break-word;
}

.cols {
  padding-top: 0;
}
</style>